<template>
  <div class="component-clients">
    <div class="clients-top">
      <h1 class="title">Record of Participation</h1>
      <p class="desc">Please select clients who have completed the module</p>
      <p class="list-title">Client List{{ loginUser.team.name ? ` - ${loginUser.team.name}` : '' }}</p>
      <div class="add-btn hub-link hub-grey" @click="addClient" @keypress.enter="addClient">
        <inline-svg :src="$assets.svg['add-client-1']" height="80%" />
        <span>New Client</span>
      </div>
    </div>
    <div class="client-list">
      <ul class="head">
        <li>
          <div class="avatar">Avatar</div>
          <div class="identification">Identification</div>
          <div class="select-status">Participant</div>
        </li>
      </ul>
      <ul class="records">
        <li
          v-for="client in clientList"
          :key="client.id"
          @click="clickClient(client)"
          @keypress.enter="clickClient(client)"
        >
          <div class="avatar">
            <div class="avatar-svg" :style="{ background: client.avatarColor }">
              <inline-svg :src="$assets.svg.avatar[client.avatarKey]" height="100%" fill="#FFFFFF" />
            </div>
          </div>
          <div class="identification">{{ client.code }}</div>
          <div class="select-status">
            <span :class="{ circle: true, green: client.selected }" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue';
import { useRouter } from 'vue-router';

import $assets from '@/assets';
import ClientService from '@/services/client';
import useSessionStore from '@/stores/session';

const emit = defineEmits(['updateClientList']);
const props = defineProps({
  selectedIds: {
    type: Array,
    default: () => [],
  },
});

const $router = useRouter();
const SessionStore = useSessionStore();
const clientList = ref([]);

const loginUser = computed(() => {
  return SessionStore.loginUser;
});

onBeforeMount(async () => {
  const activeClientResults = await ClientService.getActiveClients(loginUser.value.team.id);
  activeClientResults.records.forEach((client) => {
    const record = client;
    record.selected = props.selectedIds.includes(record.id);
    clientList.value.push(record);
  });
});

function clickClient(cl) {
  const client = cl;
  client.selected = !client.selected;
  emit(
    'updateClientList',
    clientList.value.filter((c) => c.selected)
  );
}

function addClient() {
  $router.push({ name: 'newClient' });
}
</script>

<style scoped>
.component-clients {
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
}

/** Top information */
.clients-top .title {
  margin: 1em 0 0;
  padding: 0;
}
.clients-top .desc {
  font-size: 1.1em;
  color: #6d6e71;
}
.clients-top .list-title {
  font-size: 1.3em;
  color: #6d6e71;
}

.add-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  height: 2em;
  padding-right: 1em;
}
.add-btn svg {
  margin-right: 0.5em;
}

/** Client list */
.client-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.client-list .head li {
  color: #000;
}

/** Record rows */
.client-list .records {
  flex: 1;
  color: #666;
  overflow-y: auto;
}
.client-list li {
  display: grid;
  grid-template-columns: 6em 1fr 5em;
  align-items: center;
  min-height: 4em;
  border-top: 1px solid #a7a9ac;
  padding: 0 1em;
}

.client-list li {
  cursor: pointer;
}
.client-list li:hover {
  background: #eee;
}
.client-list li > .select-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.records li:last-child {
  border-bottom: 1px solid #a7a9ac;
}

.client-list .avatar-svg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.8em;
  height: 1.8em;
  padding: 0.6em;
  border-radius: 50%;
}
.circle {
  display: inline-block;
  margin: 0;
  padding: 0;
  width: 1.2em;
  height: 1.2em;
  border-radius: 50%;
  border: 1px solid #a7a9ac;
  background: #fff;
}
.circle.green {
  background: #8ac640;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .client-list li {
    grid-template-columns: 10em 1fr 8em;
    padding: 0 0 0 2em;
  }
}
</style>
